import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';

import { initFirebase } from './Firebase';
import HomeScreen from './layouts/HomeScreen';
import reportWebVitals from './reportWebVitals';

import './index.css';


initFirebase();

ReactDOM.render(
  <React.StrictMode>
    <HomeScreen />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
